<script>
  import { apiServer } from "../config.js";
  import { fade } from "svelte/transition";
  import Alert from "../components/Alert.svelte";
  import Title from "../components/Title.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import AXHR from "../components/js/axhr.js";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (sessions.loggedin == true) {
    if (sessions.user.firstName != undefined) {
      navigation["message"] =
        sessions.user.firstName + " " + sessions.user.lastName;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  let alert = [];
  let shake = "shake";
  let require;

  $: require = {
    firstname: "",
    lastname: "",
  };
  let number;
  $: number = {};

  let email;
  $: email = {};

  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        errorForm = [
          ...errorForm,
          { field: e, message: "Pastikan Email sudah tepat" },
        ];
        if (document.getElementById(e + "-warning")) {
          document.getElementById(e + "-warning").style.display =
            "inline-block";
          document.getElementById(e + "-warning").innerHTML =
            "Pastikan Email sudah tepat";
        }
        if (document.getElementById(e + "-labelwarning")) {
          document.getElementById(e + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  let loading = false;
  let success;
  $: success = false;
  async function handleSubmit(event) {
    loading = true;
    let valid;
    let payload;
    let method = "put";
    let apiEndPoint = apiServer + "/accounts/" + sessions.user.id + "/profile";

    valid = validator();
    payload = {
      firstName: require.firstname,
      lastName: require.lastname,
    };
    shake = "";
    var data = payload;

    if (valid) {
      shake = "";
      var config = {
        method: method,
        url: apiEndPoint,
        headers: {
          Authorization: "Bearer " + sessions.token,
        },
        data: data,
      };

      AXHR(config)
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.message,
              color: "green",
            },
          ];
          success = true;
          loading = false;
        })
        .catch(function (error) {
          success = false;
          loading = false;

          shake = "shake";
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        });
    } else {
      success = false;
      loading = false;
      shake = "shake";
    }
  }
</script>

<svelte:head>
  <title>Account Manage - Mikhub</title>
</svelte:head>

{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar backbtn="false" message={navigation["message"]} align="center" />
<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0"
>
  <div class="pt-2 mx-auto my-5 lg:mt-10 lg:my-0">
    <div class="max-w-lg mx-auto rounded-lg">
      <div class="w-full mx-auto my-5 lg:my-0">
        <div class="w-full mx-auto mb-2">
          <div class="p-10 pt-5 bg-white rounded-md shadow-md {shake}">
            <Title
              subtitle="Your Account Profile"
              tipe="2"
              title="Account Profile"
            />

            <form
              class="px-2"
              autocomplete="off"
              on:submit|preventDefault={handleSubmit}
            >
              <section class="mt-5">
                <label
                  for="firstname"
                  class="relative block text-sm font-light"
                >
                  <input
                    class="w-full rounded-lg form-input"
                    name="firstname"
                    id="firstname"
                    autocomplete="off"
                    type="text"
                    placeholder={sessions.user.firstName}
                    bind:value={require.firstname}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="firstname-labelwarning"
                    >First Name
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="firstname-warning"
                  />
                </label>
              </section>

              <section class="mt-5">
                <label for="lastname" class="relative block text-sm font-light">
                  <input
                    class="w-full rounded-lg form-input"
                    name="lastname"
                    id="lastname"
                    autocomplete="off"
                    type="text"
                    placeholder={sessions.user.lastName}
                    bind:value={require.lastname}
                  />
                  <span
                    class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                    id="lastname-labelwarning"
                    >Last Name
                  </span>
                  <span
                    class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                    id="lastname-warning"
                  />
                </label>
              </section>

              <div class="flex items-center justify-between my-5">
                {#if loading}
                  <button
                    type="submit"
                    class="w-auto px-5 py-2 text-gray-100 bg-gray-700 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                    disabled="disabled"
                  >
                    PROCESS...
                  </button>
                {:else}
                  <button
                    type="submit"
                    class="w-auto px-5 py-2 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                    on:click={handleSubmit}
                  >
                    UPDATE
                  </button>
                {/if}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
